module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/capone.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/capone.png
// module id = 1157
// module chunks = 0